import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LOGIN, ROUTE_NOT_ALLOWED } from '../constants/routeConstants';
import { customStorage, getPayloadData } from '../services/UtilityService';
import { TOKEN_SESSION_KEY } from '../constants/commonConstants';
import { getProductPictures } from '../services/ManagementService';

const AppContext = createContext();

export const useAppContext = () => {
    return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [tokenTimeout, setTokenTimeout] = useState(false);
    const [showApiErrorMessage, setShowApiErrorMessage] = useState(null);
    const [token, setToken] = useState(null);
    const [mainMenu, setMainMenu] = useState(null);
    const [appSettings, setAppSettings] = useState(null);
    const [routeNaviData, setRouteNaviData] = useState("");
    const [pictureIncludedProductIdList, setPictureIncludedProductIdList] = useState([]);
    const [productPictureList, setProductPictureList] = useState([]);
    const navigate = useNavigate();

    // Handle token expiry (401 error)
    const handleTokenExpiry = () => {
        const sessionToken = customStorage.getItem(TOKEN_SESSION_KEY);
        if (!sessionToken) {
            logout();
        } else {
            sessionTimeoutLogout();
        }
    };

    // Handle Forbidden errors (403)
    const handleForbiddenError = () => {
        navigate(ROUTE_NOT_ALLOWED);
    };

    // Handle other errors
    const handleServer500Error = (error) => {
        console.error('API Error:', error);
    };

    useEffect(() => {
        const loginToken = customStorage.getItem(TOKEN_SESSION_KEY);
        if (loginToken) {
            setToken(loginToken);
            const loginUser = getPayloadData(loginToken);
            if (!loginUser) {
                clearSession();
            }
        } else {
            clearSession();
        }
    }, [token, navigate]);

    useEffect(() => {
        // const handleBeforeUnload = (event) => {
        //     const message = "Page Close Message";
        //     event.returnValue = message;
        //     return message;
        // };

        // window.addEventListener('beforeunload', handleBeforeUnload);

        const loadSettingsData = async () => {
            try {
                const settingsData = await fetch('/appSettings.json'); // Adjust the path to your JSON file
                const data = await settingsData.json();
                setAppSettings(data);
            } catch (error) {
                console.error('fetch settings error', error);
            } finally {
            }
        };
        loadSettingsData();

        // return () => {
        //     window.removeEventListener('beforeunload', handleBeforeUnload);
        // };
    }, []);

       useEffect(() => {
        const productIdsToLoadPicture = (pictureIncludedProductIdList || []).filter(pId => !productPictureList.find(pp => pp.productId === pId)).map((pId) => pId);
        console.log({ productIdsToLoadPicture })
        if (productIdsToLoadPicture.length > 0) {
            loadProductPictures(productIdsToLoadPicture);
        }
    }, [pictureIncludedProductIdList]);

    const loadProductPictures = async (productIdsToLoadPicture) => {
        try {
            setLoading(true);
            const response = await getProductPictures(productIdsToLoadPicture);
            setProductPictureList(prev => {
                const existingIds = new Set(prev.map(p => p.productId));

                const newItems = response.filter(
                    item => !existingIds.has(item.productId)
                );

                return [...prev, ...newItems];
            });
        } catch (error) {

        }finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        console.log({ productPictureList })
    }, [productPictureList])

    const logout = () => {
        clearSession();
        navigate(ROUTE_LOGIN);
    }

    const sessionTimeoutLogout = () => {
        logout();
        setTokenTimeout(true);
    }

    const clearSession = () => {
        customStorage.clear();
        setToken(null);
    }

    return (
        <AppContext.Provider value={{
            loading, setLoading, setToken, logout, tokenTimeout, setTokenTimeout, sessionTimeoutLogout,
            showApiErrorMessage, setShowApiErrorMessage, mainMenu, setMainMenu, appSettings, routeNaviData, setRouteNaviData,
            setPictureIncludedProductIdList, productPictureList
        }}>
            {children}
        </AppContext.Provider>
    );
};
